import React, { useState, useEffect, useRef } from 'react';
import SummaryCauses from './SummaryCauses';
import SummaryOptions from './SummaryOptions';
import SummarySummary from './SummarySummary';
import SummaryRecommend from './SummaryRecommend';
import { ReactComponent as PrintIcon } from '../../../assets/print.svg';
import { addDetectUserEvents, removeDetectUserEvents, useDetectMobile, formatCardLoadTiming } from '../utils';
import '../../../stylesheets/triagebot/Summary.scss';
import SummaryThankYou from './SummaryThankYou';
import { useTiming } from '../TimingContext';

const SummaryMessage = ({ message, sendMessage, setToastMessage, disabled, HoverColor, setSuppressSummary, setPrintData , locale}) => {
    const CARE_OPTIONS_TAB = 0;
    const SUMMARY_TAB = 1;
    const [selectedTab, setSelectedTab] = useState(CARE_OPTIONS_TAB);
    const [submitted, setSubmitted] = useState(false);

    var timer = null;

    const { isMobile } = useDetectMobile();

    const isDisabled = submitted || disabled;
    const pageHeader = message?.data?.[2]?.summaryCardContent?.pageHeader;
    const printText = message?.data?.[2]?.summaryCardContent?.printText;

    const tabs = message?.data?.[2].summaryCardContent?.tabHeaders
        ? message.data[2].summaryCardContent.tabHeaders
        : ['#######', '#######']

    const showSummaryOptions = message?.data?.[2].careOptionsData?.showCareOptions
        ? message.data[2].careOptionsData.showCareOptions
        : ''

    const tabSelected = (tab) => {
        setSelectedTab(tab);

        setTimeout(() => {
            document.activeElement.blur();
        }, 0);
    }

    const handleTimerOut = () => {
        //        sendMessage('message', 'NPS Timeout', 'NPS Timeout');
        removeDetectUserEvents(resetTimer);
    }

    const resetTimer = () => {
        timer && clearTimeout(timer);

        timer = setTimeout(handleTimerOut, 5000);
    }

    const pdfheader = message?.data?.[2].summaryCardContent?.pdfSymptomHeader
        ? message.data[2].summaryCardContent.pdfSymptomHeader
        : ''

    useEffect(() => {
        resetTimer();
        addDetectUserEvents(resetTimer);

        setSuppressSummary(true);

        return () => {
            clearTimeout(timer);
            removeDetectUserEvents(resetTimer);
        }
    }, [])

    function printWithSpecialFileName() {
        const today = (new Date()).toLocaleDateString('en-US');
        var tempTitle = document.title;
        document.title = pdfheader + ` (${today}).pdf`;
        window.print();
        document.title = tempTitle;

    }
    const messageRef = useRef();

    useEffect(() => {
        if (messageRef.current) {
            messageRef.current.scrollIntoView(
                {
                    behavior: 'smooth',
                    block: 'start'
                })
        }
    }, []);

    const { logTiming } = useTiming();
    const cardName = (message?.data?.[0]?.question_id) ? message.data[0].question_id : "Summary";

    useEffect(() => {
        if (message._sentAt) {
            const totalTime = (performance.now() - message._sentAt) / 1000;
            const formattedTime = formatCardLoadTiming(totalTime);
            logTiming({
                card: cardName,
                time: formattedTime
            });
        }
    }, []);

    return (
        <div className={'tabbed summary card'} ref={messageRef}>
            <div className='header' style={{ color: `var(--primary-color)` }} id='nps-range-card'>
                <h2 className='headerText1'>{pageHeader}</h2>
            </div>
            <div className='tabbar' role="tablist">
                <button
                    id="care-options-tab"
                    role="tab"
                    aria-selected={selectedTab === CARE_OPTIONS_TAB}
                    aria-controls="care-options-panel"
                    className={selectedTab === CARE_OPTIONS_TAB ? 'selected tab' : 'tab'}
                    onClick={() => tabSelected(CARE_OPTIONS_TAB)}
                    disabled={disabled}
                >
                    {tabs[0]}
                </button>
                <button
                    id="summary-tab"
                    role="tab"
                    aria-selected={selectedTab === SUMMARY_TAB}
                    aria-controls="summary-panel"
                    className={selectedTab === SUMMARY_TAB ? 'selected tab' : 'tab'}
                    onClick={() => tabSelected(SUMMARY_TAB)}
                    disabled={disabled}
                >
                    {tabs[1]}
                </button>
                {
                    isMobile
                        ?
                        <></>
                        :
                        <button
                            className='print'
                            onClick={printWithSpecialFileName}
                        >
                            <PrintIcon />
                            <span><b>{printText}</b></span>
                        </button>
                }
            </div>

            <div 
                id="care-options-panel"
                role="tabpanel"
                aria-labelledby="care-options-tab"
                className='tab-area' 
                style={selectedTab === CARE_OPTIONS_TAB ? { display: 'block' } : { display: 'none' }} 
            >
                <SummaryRecommend message={message} />
                <SummaryCauses message={message} setToastMessage={setToastMessage} />
                {
                    showSummaryOptions
                        ?
                        <SummaryOptions message={message} setToastMessage={setToastMessage} sendMessage={sendMessage} disabled={isDisabled} setSubmitted={submitted => setSubmitted(submitted)} HoverColor={HoverColor} locale={locale} />
                        :
                        <SummaryThankYou message={message} HoverColor={HoverColor} />
                }
            </div>

            <div 
                id="summary-panel"
                role="tabpanel"
                aria-labelledby="summary-tab"
                className='tab-area' 
                style={selectedTab === SUMMARY_TAB ? { display: 'block' } : { display: 'none' }}
            >
                <SummarySummary message={message} />
            </div>
        </div >);
}

export default SummaryMessage;